// @ts-nocheck
import React from 'react';
import WrapWithProviders from './wrapWithProviders';
import './src/styles/reset.css';
import './src/styles/main.css';

export const wrapRootElement = ({ element }) => {
  return <WrapWithProviders>{element}</WrapWithProviders>;
};
